/**
 * Backoffice vocabulary. Mirrors workflow-api/constants/backoffice.js — keep the keys in step.
 */

export const SERVICES = {
	payroll: { key: "payroll", label: "Payroll", color: "var(--bo-svc-payroll)", cls: "payroll", add: "green", periodType: "biweekly" },
	monthend: { key: "monthend", label: "Month-end bookkeeping", color: "var(--bo-svc-monthend)", cls: "monthend", add: "", periodType: "month" },
	ap: { key: "ap", label: "Accounts payable (AP)", color: "var(--bo-svc-ap)", cls: "ap", add: "orange", periodType: "week" },
	adhoc: { key: "adhoc", label: "Ad hoc", color: "var(--bo-svc-adhoc)", cls: "adhoc", add: "purple", periodType: "month" },
};

export const SERVICE_ORDER = ["payroll", "monthend", "ap", "adhoc"];

export const STATUSES = {
	not_started: { key: "not_started", label: "Not Started", cls: "notstarted" },
	in_progress: { key: "in_progress", label: "In Progress", cls: "progress" },
	pending_client: { key: "pending_client", label: "Pending Client", cls: "pending" },
	complete: { key: "complete", label: "Complete", cls: "complete" },
};

export const STATUS_ORDER = ["not_started", "in_progress", "pending_client", "complete"];

export const FREQUENCIES = {
	one_time: "One-time",
	weekly: "Weekly",
	biweekly: "Bi-weekly",
	monthly: "Monthly",
	quarterly: "Quarterly",
	annually: "Annually",
};

export const REPEAT_RULES = {
	same_day: "Same day each period (e.g. the 3rd of every month)",
	relative_period_end: "Relative to period end (e.g. 3 business days after month end)",
	specific_weekday: "Specific weekday (e.g. every other Friday)",
};

export const ACCOUNT_TYPES = {
	bank: "Bank",
	cc: "Credit card",
	clearing: "Clearing",
	loan: "Loan / LOC",
	other: "Other",
};

export const CADENCES = {
	every_3_days: "Remind every 3 days until task resolved",
	every_2_days: "Remind every 2 days until task resolved",
	weekly: "Remind weekly until task resolved",
	once: "Send once, no follow-up",
};

export const FIRST_SENDS = {
	on_start: "On task start date",
	day_before_start: "Day before start",
	on_due: "On due date",
};

export const ACCOUNT_RULES = {
	none: "No accounts",
	bank_cc: "Bank & credit card accounts",
	clearing: "Clearing accounts",
	trust: "Trust accounts",
};

export const GROUP_PRESETS = ["Request from Client", "Account Reconciliation", "Adjustments & Accruals"];

export const ROLES = {
	preparer: { key: "preparer", short: "P", label: "Preparer", cls: "p", idField: "preparerUserId" },
	reviewer: { key: "reviewer", short: "R", label: "Reviewer", cls: "r", idField: "reviewerUserId" },
	manager: { key: "manager", short: "M", label: "Manager", cls: "m", idField: "managerUserId" },
};

export const ROLE_ORDER = ["preparer", "reviewer", "manager"];

/**
 * Pay periods are two weeks anchored at this Monday; must match the API.
 */
export const PAYROLL_EPOCH = "2026-01-05";

export const EMAIL_VARIABLES = ["contact_first_name", "contact_name", "client_name", "period", "task_name", "due_date", "sender_name"];
